import { render, staticRenderFns } from "./HostingInstitutionIcon.vue?vue&type=template&id=1346321e"
import script from "./HostingInstitutionIcon.vue?vue&type=script&lang=js"
export * from "./HostingInstitutionIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports